import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { productApi, type Product } from '../../api/products';

export function ProductApprovalPage() {
  const { id = '' } = useParams();
  const [product, setProduct] = useState<Product | null>(null);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void productApi.get(id).then(setProduct);
  }, [id]);

  async function act(reject: boolean) {
    setBusy(true);
    try {
      setProduct(await productApi.approve(id, { reject, comment }));
    } finally {
      setBusy(false);
    }
  }

  async function publish() {
    setBusy(true);
    try {
      setProduct(await productApi.publish(id));
    } finally {
      setBusy(false);
    }
  }

  if (!product) return <p className="p-6">Loading…</p>;

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to={`/products/${id}`} className="text-sm text-slate-600 hover:underline">← Product</Link>
      <h1 className="mt-4 text-2xl font-semibold">Approval & Publishing</h1>
      <p className="mt-2 text-sm capitalize text-slate-600">{product.name} · {product.status.replace(/_/g, ' ')}</p>
      <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Review comment" className="mt-6 w-full rounded-lg border px-3 py-2 text-sm" rows={3} />
      <div className="mt-4 flex flex-wrap gap-2">
        <button disabled={busy} onClick={() => void act(false)} className="rounded-lg border px-4 py-2 text-sm">Approve</button>
        <button disabled={busy} onClick={() => void act(true)} className="rounded-lg border px-4 py-2 text-sm">Reject</button>
        <button disabled={busy} onClick={() => void publish()} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Publish / Unpublish</button>
      </div>
    </div>
  );
}
